
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import React from "react";
import FreightVIew from "../components/FreightView";
import firebase from "./../Backend/firebase";
import { TextField, Typography } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

import Arrow from 'react-arrow'

function ClientDash() {
    const dropOff = 'Drop-off-at-client';
    const yardEntry = 'Yard-Entry';
    const pickUp = 'Pick-Up-By-Driver';
    const midWay = 'Midway-to-the-journey';
    const signOff = "Customer-Signature";

    const backSide ='Back-Side';
    const frontSide = 'Front-Side';
    const leftSide =  "Left-Side";
    const rightSide = "Right-Side";
    const ceiling =  "Ceiling";
    const floorCarpet = "Floor-And-Carpet";    
    const matress = "Matress";
    const fridge = "Fridge";
    const tv = 'TV';


    let navigate = useNavigate();
    const [vins, setVins] = React.useState([]);
    const [filterNode, setFilterNode] = React.useState(yardEntry)
    const [searchText, setSearchText] = React.useState("");
    const searchInputRef = React.useRef(null);
    const [clientName, setClientName] = React.useState("");
    const [clientPin, setClientPin] = React.useState(null)

    React.useEffect(() => {
        const pin = localStorage.getItem('pin');
        setClientPin(pin)
        if (pin) {
            firebase.database.ref("1/clients")
                .orderByChild('pin').equalTo(pin)
                .once('value', snapshot => {
                    const clientData = snapshot.val();

                    if (clientData && clientData[pin]) {
                        
                        var path = "1/vins";
                        firebase.database.ref(path)
                            .once('value', snapshot => {
                                let allVins = snapshot.val();
                                if (allVins) {
                                    // eslint-disable-next-line react-hooks/exhaustive-deps
                                    setVins(Object.values(allVins).filter(vin => {
                                        return vin.client === pin;
                                    }));
                                }
                            })
                    }
                    if (clientData && clientData[pin]) {

                        setClientName(clientData[pin].name);
                    }
                })

        }
        else {
            navigate("/entry");
        }

    }, [])


    function toLower(txt) {
        return txt?.toLowerCase();
    }


    return (
        <React.Fragment>
            <CssBaseline />

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', pt: 2, mb: 2, mr: 2 }}>
                <Button variant="outlined" onClick={() => { localStorage.removeItem("pin"); navigate("/") }}>sign Out</Button>
            </Box>

            {clientName && <Typography color={"black"} mt={5} mb={5} ml={5} variant="h5" gutterBottom component="div">Hi {clientName}</Typography>}


            <TextField ml={5} sx={{ colour: "white" }} fullWidth label="Search by Chasis or route or driver or truck or date" id="fullWidth"
                inputRef={searchInputRef} onChange={(text) => {
                    setFilterNode("")
                    setSearchText(toLower(searchInputRef?.current?.value));
                }} />
            {vins && vins.map &&
                vins?.map(vin => {

                    let pass = true;

                    if (filterNode !== "") {
                        pass = false
                        if (vin[filterNode] !== null) {
                            pass = true;
                        }
                    } else {



                        if (searchText != "") {
                            pass = false;
                        }

                        if ((toLower(vin.vin)?.search(searchText)) > -1) {
                            pass = true;
                        }



                        if ((toLower(vin.driver)?.search(searchText)) > -1) {
                            pass = true;
                        }

                        if ((toLower(vin.pickup + vin.dropoff + vin)?.search(searchText)) > -1) {
                            pass = true;
                        }
                    }

                    if (!pass) {
                        return null;
                    }


                    // return <LoadScript
                    //     googleMapsApiKey="AIzaSyCEwQ9NbPmTMGgFB0ro2XIVJCA5COwFg24"
                    // >
                    return (
                    
                    <div>
                        <h4> &nbsp; &nbsp;{vin.vin}</h4>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', pt: 2, mb: 2, mr: 6, ml: 6 }}>
                    <Button
                        sx={{
                            backgroundColor: (vin[yardEntry] ? "green" : "orange"),
                            color: 'black'
                        }}
                        variant="outlined" size="large" onClick={() => { setFilterNode(yardEntry) }}>In Yard</Button>
                          <Arrow
                                                        direction="right"
                                                        shaftWidth={10}
                                                        shaftLength={20}
                                                        headWidth={30}
                                                        headLength={15}
                                                        fill="transparent"
                                                        stroke="orange"
                        
                                                        strokeWidth={2}
                        
                                                    />
                     <Button
                        sx={{
                            backgroundColor: (vin[pickUp] ? "green" : "orange"),
                            color: 'black'
                        }}
                        variant="outlined" size="large" onClick={() => { setFilterNode(pickUp) }}>Loaded On Truck</Button>
                                                  <Arrow
                                                        direction="right"
                                                        shaftWidth={10}
                                                        shaftLength={20}
                                                        headWidth={30}
                                                        headLength={15}
                                                        fill="transparent"
                                                        stroke="orange"
                        
                                                        strokeWidth={2}
                        
                                                    /> 
            <Button
                        sx={{
       backgroundColor: (vin[yardEntry] && vin[pickUp]  && vin[dropOff])  ? "green" : (vin[yardEntry] && vin[pickUp]  ? "orange": "white"),
                            color: 'black'

                        }}
                        variant="outlined" size="large" onClick={() => { setFilterNode(midWay) }}>Mid way</Button>
                                                  <Arrow
                                                        direction="right"
                                                        shaftWidth={10}
                                                        shaftLength={20}
                                                        headWidth={30}
                                                        headLength={15}
                                                        fill="transparent"
                                                        stroke="orange"
                        
                                                        strokeWidth={2}
                        
                                                    />
       <Button
                        sx={{
                            backgroundColor: (vin[dropOff] ? "green" : "orange"),
                            color: 'black'
                        }}
                        variant="outlined" size="large" onClick={() => { setFilterNode(dropOff) }}>Drop Off</Button>
                                                  <Arrow
                                                        direction="right"
                                                        shaftWidth={10}
                                                        shaftLength={20}
                                                        headWidth={30}
                                                        headLength={15}
                                                        fill="transparent"
                                                        stroke="orange"
                        
                                                        strokeWidth={2}
                        
                                                    />
                                                          
                 <Button
                        sx={{
                            backgroundColor: (vin['isCustomerSignOff'] ? "green" : "orange"),

                            color: 'black'
                        }}
                        variant="outlined" size="large" onClick={() => { setFilterNode(signOff) }}>Sign Off</Button>

                </Box>
    
                    <FreightVIew ml={5}

                        chasis={vin.vin}
                        route={vin.pickup + " to " + vin.destination}
                        plannedDate={vin.plannedDate}
                        actualDate={vin.actualDate}
                        status={vin.status}
                        stage={filterNode}
                        driver={vin.driver}
                        clientPin={localStorage.getItem('pin')}
                        backSideUrl = {vin[filterNode] && vin[filterNode][backSide] ? vin[filterNode][backSide].url : ""}
                        backSideDate = {vin[filterNode] && vin[filterNode][backSide] ? vin[filterNode][backSide].date : ""}
                        backSideLocation = {vin[filterNode] && vin[filterNode][backSide] ? vin[filterNode][backSide].location : ""}

                        frontSideUrl = {vin[filterNode] && vin[filterNode][frontSide] ? vin[filterNode][frontSide].url : ""}
                        frontSideDate = {vin[filterNode] && vin[filterNode][frontSide] ? vin[filterNode][frontSide].date : ""}
                        frontSideLocation = {vin[filterNode] && vin[filterNode][frontSide] ? vin[filterNode][frontSide].location : ""}

                        leftSideUrl = {vin[filterNode] && vin[filterNode][leftSide] ? vin[filterNode][leftSide].url : ""}
                        leftSideDate = {vin[filterNode] && vin[filterNode][leftSide] ? vin[filterNode][leftSide].date : ""}
                        leftSideLocation = {vin[filterNode] && vin[filterNode][leftSide] ? vin[filterNode][leftSide].location : ""}

                        rightSideUrl = {vin[filterNode] && vin[filterNode][rightSide] ? vin[filterNode][rightSide].url : ""}
                        rightSideDate = {vin[filterNode] && vin[filterNode][rightSide] ? vin[filterNode][rightSide].date : ""}
                        rightSideLocation = {vin[filterNode] && vin[filterNode][rightSide] ? vin[filterNode][rightSide].location : ""}

                        ceilingUrl = {vin[filterNode] && vin[filterNode][ceiling] ? vin[filterNode][ceiling].url : ""}
                        ceilingDate = {vin[filterNode] && vin[filterNode][ceiling] ? vin[filterNode][ceiling].date : ""}
                        ceilingLocation = {vin[filterNode] && vin[filterNode][ceiling] ? vin[filterNode][ceiling].location : ""}

                        floorUrl = {vin[filterNode] && vin[filterNode][floorCarpet] ? vin[filterNode][floorCarpet].url : ""}
                        floorDate = {vin[filterNode] && vin[filterNode][floorCarpet] ? vin[filterNode][floorCarpet].date : ""}
                        floorLocation = {vin[filterNode] && vin[filterNode][floorCarpet] ? vin[filterNode][floorCarpet].location : ""}

                        fridgeUrl = {vin[filterNode] && vin[filterNode][fridge] ? vin[filterNode][fridge].url : ""}        
                        fridgeDate = {vin[filterNode] && vin[filterNode][fridge] ? vin[filterNode][fridge].date : ""}
                        fridgeLocation = {vin[filterNode] && vin[filterNode][fridge] ? vin[filterNode][fridge].location : ""}

                        tvUrl = {vin[filterNode] && vin[filterNode][tv] ? vin[filterNode][tv].url : ""}
                        tvDate = {vin[filterNode] && vin[filterNode][tv] ? vin[filterNode][tv].date : ""}
                        tvLocation = {vin[filterNode] && vin[filterNode][tv] ? vin[filterNode][tv].location : ""}

                        mattressUrl = {vin[filterNode] && vin[filterNode][matress] ? vin[filterNode][matress].url : ""}
                        mattressDate = {vin[filterNode] && vin[filterNode][matress] ? vin[filterNode][matress].date : ""}
                        mattressLocation = {vin[filterNode] && vin[filterNode][matress] ? vin[filterNode][matress].location : ""}
                        lastLocation = {vin['lastLocation']}
                    >

                    </FreightVIew>
                    <hr></hr>
                    <matDivider></matDivider>
                    </div>)
                    //  </LoadScript>
                })
            }

        </React.Fragment >
    );
}
export default ClientDash;